import React from 'react';
import { connect } from 'react-redux';
import restClient, { httpClient } from '../restClient';
import Grid from '@material-ui/core/Grid';
import CountCard from '../common/CountCard';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = {
  button: { margin: '12px', background: 'none' },
  linearProgress: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0.4,
    borderRadius: 4
  }
};

const client = restClient(httpClient);

class Header extends React.Component {
  state = { totalUsers: 0, totalGamesCreated: 0, totalActiveUsers: 0 };

  getSummary() {
    const { resource, queryParams } = this.props;
    client('GET_LIST_SUMMARY', resource, queryParams).then(response =>
      this.setState({
        totalUsers: response.data.total_users,
        totalActiveUsers: response.data.total_active_users,
        totalGamesCreated: response.data.total_games,
        totalTeams: response.data.total_teams,
        totalPlayedGames: response.data.total_played_games
      })
    );
  }

  componentDidMount() {
    this.getSummary();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.queryParams.filter !== this.props.queryParams.filter) {
      this.getSummary();
    }
  }

  render() {
    let linearProgressBar = (
      <LinearProgress color="secondary" className={styles.linearProgress} />
    );
    return (
      <Grid
        container
        spacing={16}
        alignItems="flex-start"
        direction="row"
        justify="flex-start"
      >
        <input
          type="hidden"
          id="total_business"
          value={this.props.totalBusiness}
        />
        <input type="hidden" id="total_users" value={this.state.totalUsers} />
        <input
          type="hidden"
          id="total_active_users"
          value={this.state.totalActiveUsers}
        />
        <input
          type="hidden"
          id="total_games"
          value={this.state.totalGamesCreated}
        />
        <input
          type="hidden"
          id="total_played_games"
          value={this.state.totalPlayedGames}
        />
        <input type="hidden" id="total_teams" value={this.state.totalTeams} />

        {/* SUMMARY TOTAL COUNTS BELOW
         
         Business count */}
        <Grid key="Business" item>
          {true > 0 && (
            <CountCard title="Business" value={this.props.totalBusiness} />
          )}

          {this.state.totalBusiness == 0 && (
            <div>
              <ProgressButton title={'Business'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>

        {/* Users count */}
        <Grid key="Users" item>
          {this.state.totalUsers > 0 && (
            <CountCard title="Users" value={this.state.totalUsers} />
          )}

          {this.state.totalUsers == 0 && (
            <div>
              <ProgressButton title={'Users'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>

        {/* Active users count */}
        <Grid key="Active Users" item>
          {this.state.totalActiveUsers > 0 && (
            <CountCard
              title="Active Users"
              value={this.state.totalActiveUsers}
            />
          )}
          {this.state.totalActiveUsers == 0 && (
            <div>
              <ProgressButton title={'Active Users'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>

        {/* Created Games count */}
        <Grid key="Created Games" item>
          {this.state.totalGamesCreated > 0 && (
            <CountCard
              title="Created Games"
              value={this.state.totalGamesCreated}
            />
          )}

          {this.state.totalGamesCreated == 0 && (
            <div>
              <ProgressButton title={'Created Games'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>

        {/* Played Games count */}
        <Grid key="Played Games" item>
          {this.state.totalGamesCreated > 0 && (
            <CountCard
              title="Played Games"
              value={this.state.totalPlayedGames}
            />
          )}

          {this.state.totalGamesCreated == 0 && (
            <div>
              <ProgressButton title={'Played Games'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>

        {/* Teams count */}
        <Grid key="Teams" item>
          {this.state.totalGamesCreated > 0 && (
            <CountCard title="Teams" value={this.state.totalTeams} />
          )}

          {this.state.totalGamesCreated == 0 && (
            <div>
              <ProgressButton title={'Teams'} />
              {linearProgressBar}
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}

const ProgressButton = ({ title }) => (
  <Button
    variant="contained"
    color="primary"
    style={styles.button}
    disabled={true}
  >
    {' '}
    {title}{' '}
  </Button>
);

function mapStateToProps(state, props) {
  const resourceState = state.admin.resources[props.resource];
  return {
    queryParams: resourceState.list.params,
    totalBusiness: resourceState.list.total
  };
}
export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/business/Header.js